import {FC} from 'react';
import clsx from 'clsx';

import s from './styles.module.scss';

interface FooterCopyrightProps {
  instanceLabel: string;
  className?: string;
}

export const FooterCopyright: FC<FooterCopyrightProps> = ({instanceLabel, className}) => {
  return (
    <div className={clsx(s['footer-copyright'], className)}>
      <span>
        ©&nbsp;{new Date().getFullYear()}&nbsp;{instanceLabel}
      </span>
    </div>
  );
};
